"use strict";

exports.__esModule = true;
exports.StackedBar = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StackedBar = exports.StackedBar = function StackedBar(props) {
  var x = props.x,
    height = props.height,
    yScale = props.yScale,
    barWidth = props.barWidth,
    value = props.value;
  var sumOfHeight = 0;
  var topY = function topY(item) {
    return yScale(item.value);
  };
  var barHeight = function barHeight(item) {
    var barHeight = height - topY(item) < 0 ? 0 : height - topY(item);
    sumOfHeight += barHeight;
    return barHeight;
  };
  var bar = function bar(item) {
    return /*#__PURE__*/_react["default"].createElement("rect", {
      "data-key": item.key,
      fill: item.color || "inherit",
      x: x,
      y: topY(item) - sumOfHeight,
      width: barWidth,
      height: barHeight(item)
    });
  };
  return value.map(function (item) {
    return bar(item);
  });
};